import { FC, useMemo } from 'react';
import { Button as BSButton, ButtonProps as BSButtonProps, Spinner } from 'react-bootstrap';
import classlist from 'utils/classlist';

export interface ButtonProps extends Omit<BSButtonProps, 'type' | 'variant'> {
    loading?: boolean; // 显示加载中状态
    round?: boolean; // 大圆角按钮
    ghost?: boolean; // 是否背景透明模式（幽灵模式）
    type?: 'default' | 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light' | 'link'; // 风格定义，同variant
    htmlType?: BSButtonProps['type']; // 传递给按钮dom节点的type属性，type="submit"
    block?: boolean;
}

const Button: FC<ButtonProps & Omit<React.ComponentPropsWithRef<'button'>, 'type'>> = props => {
    const {
        type = 'primary',
        children,
        loading,
        round,
        ghost,
        // htmlType, 即react-bootstrap中Button组件的type属性, 一定不能传undefined, 经测试, undefined效果等同于submit
        htmlType = 'button',
        block,
        className,
        size,
        ...restProps
    } = props;
    const variant = useMemo(() => {
        if (type === 'default' && ghost) {
            return 'outline-light';
        }

        return ghost ? `outline-${type}` : type;
    }, [type, ghost]);

    return (
        <BSButton
            {...restProps}
            variant={variant}
            type={htmlType}
            size={size}
            className={classlist(className, {
                'btn-loading': loading,
                'rounded-pill': round,
                'btn-ghost': ghost,
                'btn-block': block
            })}>
            {loading && (
                <>
                    <Spinner
                        as="span"
                        className={size === 'lg' ? 'align-middle' : undefined}
                        animation="border"
                        size="sm"
                    />{' '}
                </>
            )}
            {children}
        </BSButton>
    );
};

export default Button;
